// extracted by mini-css-extract-plugin
export var contactUs = "PricingPlans-module--contactUs--44338";
export var contactWrapperAligned = "PricingPlans-module--contactWrapperAligned--e6fa0";
export var paragraph = "PricingPlans-module--paragraph--c8dad";
export var planRow = "PricingPlans-module--planRow--dc027";
export var storyCopy = "PricingPlans-module--storyCopy--7e9c0";
export var storyTooltipTrigger = "PricingPlans-module--storyTooltipTrigger--3c595";